import { ClassifiedGardeBlock } from '../../rest/types/Classified'

export function BlockGardeTransformer({
  block,
  t,
}: {
  block: ClassifiedGardeBlock
  t: any
}) {
  return {
    ...(block?.specialities && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.specialities
            ? [
                {
                  title: t('ads_types_speciality_title'),
                  texts: block?.specialities.map((item) => item.name),
                },
              ]
            : []),
        ],
      },
    }),
    adsDetailsColumn: {
      items: [
        ...(block?.doctors?.length
          ? [
              {
                label: t('ads_details_doctors_concerned_title'),
                values: block?.doctors?.map((item) =>
                  t(`ads_details_doctors_${item}`)
                ),
              },
            ]
          : []),
        ...(block?.type?.length
          ? [
              {
                label: t('ads_details_guard_type_title'),
                values: block?.type?.map((item) =>
                  t(`ads_details_guard_ad_${item}`)
                ),
              },
            ]
          : []),
        ...(block?.periods?.length
          ? [
              {
                label: t('ads_details_guard_periods_title'),
                values: block?.periods?.map((item) =>
                  t(`ads_details_guard_periods_${item}`)
                ),
              },
            ]
          : []),
        ...(block?.departments?.length
          ? [
              {
                label: t('ads_details_departments_desired_title'),
                values: block?.departments?.map((item) => item),
              },
            ]
          : []),
      ],
    },
  }
}
